export function hideEntityAction() {
  const { t } = useI18n();

  return {
    title: t('components.xeokit_viewer.context_menu.hide'),
    getEnabled: function (context) {
      return context.entity.visible;
    },
    doAction: function (context) {
      context.entity.visible = false;
    },
  };
}
